export const SELECT_AN_OPTION = 'Select an option';
